import { constants, LocalStorageService } from '@edassist/common';
import { AuthenticationService } from '../auth/auth.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HybridAuthService {
	constructor(private readonly authService: AuthenticationService) {}

	handleHybridUser(): void {
		// See if we have items set in local storage from base site (logged into base site)
		const baseSiteUserDetails = LocalStorageService.getItem(
			constants.localStorageKeys.CURRENT_USER_HYBRID
		)?.userDetails;
		const baseSiteUserTokens = LocalStorageService.getItem(constants.localStorageKeys.TOKENS_HYBRID)?.tokens;

		if (baseSiteUserDetails && baseSiteUserTokens) {
			const hybridSiteUser = {
				...baseSiteUserDetails,
				...baseSiteUserTokens
			};
			this.authService.handleUserLogin(hybridSiteUser);
		}

		if (baseSiteUserDetails && this.authService.isAuth0Authenticated) {
			this.authService.handleUserLoginWithAuth0(baseSiteUserDetails);
		}
	}
}
